import OrganizationDto from '@/common/classes/dto/OrganizationDto'
import store from '@/store'

export default class CheckNeedAttorney {
  /**
   * @param {OrganizationDto} organization
   * @returns {Promise<OrganizationDto>}
   */
  trigger(organization) {
    const need_attorney = organization.director_name !== store.dadataManagerName || organization.position_of_manager !== store.dadataManagerPosition

    return Promise
      .resolve(organization)
      .then(organization => new OrganizationDto({ ...organization, need_attorney }))
  }
}
